import { Row, Container, Col } from 'styled-bootstrap-grid'
import {
    SummaryWrapper,
    SummaryContent,
    SummaryPriceWrapper,
    SummaryButtonWrapper,
} from 'components/global/Header/styles'

import Box from 'components/shared/Box'
import Price from './SummaryPrice'
import Summary from 'components/global/Summary'
import Button from 'components/shared/Button'
import { FormattedMessage } from 'react-intl'
import SelfcareSummary from 'components/global/SelfcareSummary'
import UnlimitedMobileSummary from 'components/global/UnlimitedMobileSummary/UnlimitedMobileSummary'
import ProductList from 'components/global/Summary/sections/ProductList'
import { useApp } from 'store/steps'
import VouchersMobileSummary from 'components/global/VouchersMobileSummary'

interface MobileSummaryProps {
    close: () => void
}

const MobileSummary = ({ close }: MobileSummaryProps) => {
    const { appMode, isCreatorMode, isUnlimitedMode } = useApp()

    let summaryContent

    switch (appMode) {
        case 'creator':
        case 'creator-accommodation':
            summaryContent = <Summary productList={<ProductList />} />
            break
        case 'unlimited-card':
        case 'unlimited-renew':
            summaryContent = <UnlimitedMobileSummary />
            break
        case 'vouchers':
            summaryContent = <VouchersMobileSummary />
            break
        default:
            summaryContent = <SelfcareSummary />
    }

    return (
        <SummaryWrapper onClick={() => close()}>
            <Container>
                <Row>
                    <Col>
                        <Box
                            direction="row"
                            align="center"
                            justify="flex-end"
                            pt={18}
                            pb={10}
                        >
                            <SummaryPriceWrapper>
                                <Price />
                            </SummaryPriceWrapper>
                        </Box>
                    </Col>
                </Row>
            </Container>
            <SummaryContent onClick={(event) => event.stopPropagation()}>
                <Container>
                    <Row>
                        <Col>{summaryContent}</Col>
                    </Row>
                </Container>

                {isCreatorMode ||
                    (isUnlimitedMode && (
                        <SummaryButtonWrapper pt={16} mt={16}>
                            <Container>
                                <Row>
                                    <Col>
                                        <Button
                                            variant="borderPrimary"
                                            onClick={close}
                                        >
                                            <FormattedMessage
                                                id="global.btn.continue_shopping"
                                                defaultMessage="Kontynuuj zakupy"
                                            />
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </SummaryButtonWrapper>
                    ))}
            </SummaryContent>
        </SummaryWrapper>
    )
}

export default MobileSummary
